type Props = {
  description: string;
};

export const ListingStayDetailDescription = ({ description }: Props) => {
  const removeHtmlTag = (text: string) => {
    return text.replace(/<[^>]*>?/gm, "");
  };

  return (
    <div className="listingSection__wrap">
      <h2 className="text-2xl font-semibold">Informações do hotel</h2>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      <div className="text-neutral-6000 dark:text-neutral-300">
        {removeHtmlTag(description)}
      </div>
    </div>
  );
};
